import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import CommentForm  from 'app/components/company-admin/grant-system/comment-form';
import GrantSysDuck from 'app/ducks/company-admin/grant-system';

class NewComment extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      formKey: 1,
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  // only top-level comments can attach files
  get allowFiles() {
    if (this.props.answerId) return false;
    if (this.props.parentId) return false;
    return true;
  }

  async onSubmit(attrs) {
    const {appId, assId, answerId, parentId} = this.props;
    await this.props.createComment(appId, {
      ...attrs,
      grantAssignmentId: assId || null,
      formAnswerId: answerId || null,
      grantAppCommentId: parentId || null,
    });
    // remount the form to reset it
    this.setState((prevState) => ({formKey: prevState.formKey + 1}));
    this.props.onCreated && this.props.onCreated();
  }

  render() {
    const {className, onCancel, focusOnMount, placeholder, startCollapsed} = this.props;
    return (
      <CommentForm
        key={this.state.formKey}
        onSubmit={this.onSubmit}
        onCancel={onCancel}
        allowFiles={this.allowFiles}
        startCollapsed={startCollapsed}
        focusOnMount={focusOnMount}
        placeholder={placeholder}
        className={className}
      />
    );
  }

}

NewComment.propTypes = {
  appId: PropTypes.string.isRequired,
  assId: PropTypes.string,
  answerId: PropTypes.string,
  parentId: PropTypes.string,
  className: PropTypes.string,
  onCreated: PropTypes.func,
  onCancel: PropTypes.func,
  focusOnMount: PropTypes.bool,
  placeholder: PropTypes.string,
  startCollapsed: PropTypes.bool, // when true, starts as "Add a Comment" / "Attach a File" btns
};
NewComment.defaultProps = {
  className: '',
  onCreated: null,
  onCancel: null,
  focusOnMount: false,
  placeholder: undefined,
  startCollapsed: false,
};

const dispatchToProps = (dispatch) => ({
  createComment: (appId, attrs) => dispatch(GrantSysDuck.Ax.commentsCreate(appId, attrs)),
});

export default connect(null, dispatchToProps)(NewComment);
